import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail]   = useState("");
  const [sent, setSent]     = useState(false);
  const [err, setErr]       = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore. Riprova tra poco.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F0F2F5' }}>
      <div className="w-full max-w-[400px]">
        <div className="flex items-center gap-3 mb-10">
          <img src="/brand/logo-mark.png" alt="Best Agent" className="w-10 h-10 rounded-[5px] object-cover" />
          <div>
            <div className="font-serif text-lg font-light text-slate-900">Best Agent</div>
            <div className="text-[9px] uppercase tracking-[0.24em]" style={{ color: 'var(--gold)' }}>Private Wealth CRM</div>
          </div>
        </div>

        <div className="bg-white p-10" style={{ border: '1px solid #E8ECF2', borderRadius: 4, boxShadow: '0 4px 24px rgba(10,25,47,0.07)' }}>
          {sent ? (
            <div className="text-center py-4">
              <CheckCircle2 className="w-10 h-10 mx-auto mb-4" style={{ color: '#16A34A' }} strokeWidth={1.5} />
              <h2 className="font-serif text-2xl font-light text-slate-900 mb-2">Richiesta registrata.</h2>
              <p className="text-sm text-slate-400 mb-6">Se l'email corrisponde a un account, la richiesta è stata registrata. Contatta il tuo amministratore, che può reimpostare la password dalla pagina Team.</p>
              <Link to="/login" className="text-sm font-medium gold-link">← Torna al login</Link>
            </div>
          ) : (
            <>
              <div className="text-[10px] uppercase tracking-[0.24em] mb-2" style={{ color: 'var(--gold)' }}>Recupero password</div>
              <h1 className="font-serif text-3xl font-light text-slate-900 leading-none mb-2">Reimposta.</h1>
              <p className="text-sm text-slate-400 mb-6">Inserisci la tua email e ti mandiamo un link per reimpostare la password.</p>
              <div className="gold-rule mb-8" />

              <form onSubmit={onSubmit}>
                <label className="block text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500 mb-2">Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="nome@dominio.it"
                  className="w-full px-4 py-3 text-sm bg-slate-50 hover:bg-white focus:bg-white border border-slate-200 focus:border-slate-900 focus:ring-2 focus:ring-slate-900/8 transition-all mb-5"
                  style={{ borderRadius: 2, outline: 'none' }} />

                {err && <div className="mb-4 text-sm text-rose-700 bg-rose-50 border border-rose-200 px-4 py-3" style={{ borderRadius: 2 }}>{err}</div>}

                <button type="submit" disabled={loading}
                  className="w-full text-white font-medium py-3.5 flex items-center justify-center gap-2 text-sm transition-all disabled:opacity-60"
                  style={{ background: 'var(--navy)', borderRadius: 2 }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--navy-3)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'var(--navy)'}>
                  {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                  Invia link di recupero
                </button>
              </form>

              <div className="mt-6 text-xs text-center text-slate-500">
                <Link to="/login" className="gold-link">← Torna al login</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
